import { Card, withStyles } from '@material-ui/core';

const StyledCard = withStyles(() => ({
  root: {
    padding: '0.1rem 1rem',
    minWidth: '8.5rem',
  },
}))(Card);

export default StyledCard;
